'use es6';

import uniqueId from 'transmute/uniqueId';
import RecordFactory from '../RecordFactory';
import { AdWordsStatusMap, Networks } from '../../lib/Constants';
export default RecordFactory({
  id: null,
  adType: null,
  accountId: null,
  campaignId: null,
  network: Networks.ADWORDS,
  adGroupId: null,
  status: AdWordsStatusMap.ENABLED,
  headline: '',
  description1: '',
  description2: '',
  displayUrl: '',
  finalUrl: '',
  mobile: false,
  trackingUrlTemplate: null,
  performanceProperties: null,

  isValidForSave() {
    return this.headline && this.description1 && this.description2 && this.displayUrl;
  },

  getSearchString() {
    return `${this.headline}${this.description1}${this.description2}${this.displayUrl}`.toLowerCase();
  },

  previousState: null
}, () => {
  return {
    id: `${uniqueId() * -1}`
  };
});